import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
            悟
          </div>
          <span className="text-xl font-heading font-bold text-foreground-950">
            悟空影视
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? 'bg-primary-500/15 text-primary-500'
                : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 7).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? 'bg-accent-500/15 text-accent-500'
                : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-300/40 px-4 py-3 space-y-1">
          <Link
            to="/"
            className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 hover:text-foreground-950 whitespace-nowrap"
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 hover:text-foreground-950 whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 hover:text-foreground-950 whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}